<template>
    <div class="friends-component">
        <div class="clearfix">
            <h2>{{ $t('buscarContacto') }}</h2>
            <li class="list-group-item search-container">
                <div class="input-group modern-search-group">
                    <input
                        v-model="text"
                        v-debounceInput="onTextChange"
                        type="text"
                        class="form-control search-input"
                        id="input-name"
                        :placeholder="$t('buscarPersonas')"
                    />
                    <span class="input-group-btn">
                        <button class="btn btn-search-modern" type="button">
                            <i class="fa fa-search" aria-hidden="true"></i>
                        </button>
                    </span>
                </div>
            </li>
            <template>
                <Loading class="conversation_chat--chats" :data="users">
                    <li
                        v-for="user in users"
                        class="list-group-item conversation_header"
                    >
                        <div class="media">
                            <div class="media-left">
                                <router-link
                                    :to="{
                                        name: 'profile',
                                        params: {
                                            id: user.id,
                                            userProfile: user,
                                            activeTab: 1
                                        }
                                    }"
                                >
                                    <div
                                        class="conversation_image circle-box"
                                        v-imgSrc:profile="user.image"
                                    ></div>
                                </router-link>
                            </div>
                            <div class="media-body">
                                <h4 class="media-heading">
                                    <span class="conversation-title">{{
                                        user.name
                                    }}</span>
                                </h4>
                            </div>
                            <div class="media-right">
                                <button
                                    @click="onAddClick(user)"
                                    :class="
                                        user.state === 'none'
                                            ? 'btn-primary'
                                            : ''
                                    "
                                    class="btn"
                                    :disabled="user.state != 'none'"
                                >
                                    <span
                                        v-if="
                                            user.state == 'none' &&
                                            !idRequesting[user.id]
                                        "
                                    >
                                        {{ $t('agregar') }}
                                        <i
                                            class="fa fa-plus"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                    <span
                                        v-if="
                                            idRequesting[user.id] &&
                                            idRequesting[user.id] === true
                                        "
                                    >
                                        <spinner class="blue"></spinner>
                                    </span>
                                    <span v-if="user.state != 'none'"
                                        >{{ $t('solicitudEnviada') }}</span
                                    >
                                </button>
                            </div>
                        </div>
                    </li>
                    <template #no-data><li
                        class="list-group-item alert alert-warning"
                        role="alert"
                    >
                        {{ $t('noSeEncontraronContactos') }}
                    </li></template>
                    <template #loading><li
                        class="list-group-item alert alert-info"
                        role="alert"
                    >
                        <img
                            src="https://carpoolear.com.ar/static/img/loader.gif"
                            alt=""
                            class="ajax-loader"
                        />
                        {{ $t('buscandoContactos') }}
                    </li></template>
                </Loading>
            </template>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Loading from '../Loading.vue';
import FriendCard from './FriendCard';
import bus from '../../services/bus-event.js';
import spinner from '../Spinner.vue';

export default {
    name: 'friends_request',
    data() {
        return {
            text: '',
            idRequesting: {},
            searchingRequest: null
        };
    },
    computed: {
        ...mapGetters({
            users: 'friends/users'
        })
    },
    methods: {
        ...mapActions({
            search: 'friends/searchUsers',
            request: 'friends/request'
        }),
        onTextChange() {
            this.search(this.text);
        },

        onAddClick(user) {
            this.$set(this.idRequesting, user.id, true);
            this.request(user.id).then(
                () => {
                    this.$set(this.idRequesting, user.id, false);
                },
                () => {
                    this.$set(this.idRequesting, user.id, false);
                }
            );
        },
        onBackClick() {
            this.$router.back();
        }
    },

    mounted() {
        bus.on('back-click', this.onBackClick);
    },

    beforeDestroy() {
        bus.off('back-click', this.onBackClick);
    },
    components: {
        Loading,
        FriendCard,
        spinner
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
    border: solid 2px #fff;
    width: 132px;
    height: 42px;
    padding: 6px 12px;
    border-radius: 1px;
}
h2 {
    padding-top: 0;
}
.media-body {
    vertical-align: middle;
}
.conversation-title {
    font-size: 15px;
}
.media-right {
    position: absolute;
    right: 5px;
    top: 12px;
    line-height: 52px;
    vertical-align: middle;
}
.btn-primary {
    border-radius: 3px;
    font-size: 12px;
    padding: 0.8em 1.8em;
}
i {
    padding-left: 0.4em;
    vertical-align: 0;
}

/* Stylisation moderne du champ de recherche */
.search-container {
    padding: 20px;
    background-color: #fff;
    border: none;
    border-radius: 0;
    display: flex;
    justify-content: center;
}

.modern-search-group {
    display: flex;
    align-items: stretch;
    width: 100%;
    max-width: 500px;
}

.search-input {
    height: 50px;
    padding: 12px 20px;
    border: 2px solid #e0e0e0;
    border-right: none;
    border-radius: 12px 0 0 12px;
    font-size: 15px;
    font-family: 'Heebo', sans-serif;
    transition: all 0.3s ease;
    flex: 1;
    background-color: #fff;
}

.search-input:focus {
    outline: none;
    border-color: #59c362;
    box-shadow: 0 0 0 3px rgba(89, 195, 98, 0.1);
}

.search-input::placeholder {
    color: #999;
    font-size: 14px;
}

.btn-search-modern {
    height: 50px;
    width: 60px;
    background: linear-gradient(135deg, #59c362 0%, #48a551 100%);
    border: 2px solid #59c362;
    border-left: none;
    border-radius: 0 12px 12px 0;
    color: white;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
}

.btn-search-modern:hover {
    background: linear-gradient(135deg, #48a551 0%, #3d8f44 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(89, 195, 98, 0.3);
}

.btn-search-modern i {
    padding-left: 0;
    vertical-align: middle;
}
@media only screen and (max-width: 768px) {
    .friends-component {
        padding: 0;
    }
}
@media only screen and (max-width: 400px) {
    .input-group-btn:last-child > .btn,
    .input-group-btn:last-child > .btn-group {
        height: 26px;
    }
    .form-control {
        padding: 0.3em 0.8em;
        font-size: 12px;
    }
    .friends-component {
        padding: 0;
    }
    .btn {
        font-size: 10px;
        width: 100px;
    }
    .media-left {
        padding-right: 0;
    }
    .conversation-title {
        font-size: 13px;
    }
    .conversation_image {
        width: 36px;
        height: 36px;
    }
    .media-right[data-v-9c187428] {
        top: 2px;
    }
    .input-group-btn .btn {
        width: 50px;
    }
    .alert {
        font-size: 12px;
    }
}
@media only screen and (min-width: 768px) {
    h2 {
        margin-top: 0;
    }
}
</style>
